import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import HeroConsultationForm from './HeroConsultationForm';

const NewHeroSection = () => {
  const { language } = useLanguage();
  const sl = language === 'sl';

  return (
    <section className="bg-[#0E1114] text-[#F4EFE6]" data-testid="hero-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-[120px] pb-24">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-[72px] pt-16 lg:pt-[88px]">
          <div className="flex-1 flex flex-col gap-8">
            <div className="flex items-center gap-3 text-[13px] font-semibold tracking-[2.5px] text-[#C9A462]">
              <span className="w-8 h-px bg-[#C9A462]" />
              {sl ? 'ZA PODJETJA IN PODJETNIKE V SLOVENIJI' : 'FOR BUSINESSES AND ENTREPRENEURS IN SLOVENIA'}
            </div>
            <h1 className="font-serif text-[48px] sm:text-[64px] lg:text-[92px] leading-[0.98] tracking-[-1.5px] text-[#F7F2E9]">
              {sl ? <>Birokracijo uredimo mi.<br /><span className="italic text-[#C9A462]">Vi vodite posel.</span></> : <>We handle the paperwork.<br /><span className="italic text-[#C9A462]">You run your business.</span></>}
            </h1>
            <p className="text-[18px] lg:text-[20px] leading-[1.6] text-[#C9C3B7] max-w-[640px]">
              {sl ? <>Ustanovitev podjetja, računovodstvo, vračila DDV, delovna dovoljenja in davčno svetovanje — vse na enem mestu, z izkušeno ekipo od leta 2003. V jeziku, ki vam je najbližji. <strong className="text-[#F4EFE6] font-semibold">Vi skrbite za stranke. Za vse ostalo poskrbimo mi.</strong></> : <>Company formation, accounting, VAT refunds, work permits and tax advisory — all in one place, with an experienced team since 2003. In the language closest to you. <strong className="text-[#F4EFE6] font-semibold">You take care of your clients. We take care of everything else.</strong></>}
            </p>
            <div className="flex flex-wrap gap-4 pt-2">
              <a href="#offer" onClick={(event) => { event.preventDefault(); document.querySelector('#offer')?.scrollIntoView({ behavior: 'smooth' }); }} className="flex items-center gap-3 bg-[#C9A462] text-[#0E1114] font-bold text-[17px] px-8 py-5 no-underline hover:bg-[#B8944F]" data-testid="hero-cta-primary">
                {sl ? 'Rezervirajte brezplačen posvet' : 'Book a free consultation'}<ArrowRight className="w-[18px] h-[18px]" />
              </a>
              <a href="tel:+38638184060" className="flex items-center gap-2.5 border border-[#454C54] text-[#F4EFE6] font-semibold text-[17px] px-7 py-5 no-underline hover:bg-[#1a1d21]" data-testid="hero-cta-secondary"><Phone className="w-[18px] h-[18px]" />+386 3 818 40 60</a>
            </div>
            <div className="flex flex-wrap gap-5 text-[14px] text-[#8F897E] pt-1">
              <span>✓ {sl ? 'Pisna ponudba v 48 urah' : 'Written quote within 48 hours'}</span>
              <span>✓ {sl ? 'Brez obveznosti' : 'No obligation'}</span>
              <span>✓ {sl ? 'Prestop kadarkoli — tudi med letom' : 'Switch anytime — even mid-year'}</span>
            </div>
            <div className="flex items-center gap-3.5 flex-wrap text-[14px] text-[#C9C3B7] pt-0.5">
              <span className="text-[12px] font-bold tracking-[2px] text-[#C9A462]">{sl ? 'GOVORIMO' : 'WE SPEAK'}</span>
              {['slovensko', 'English', 'srpskohrvatski', 'español'].map((spokenLanguage) => <span key={spokenLanguage} className="border border-[#343A41] px-3 py-1.5">{spokenLanguage}</span>)}
            </div>
          </div>
          <HeroConsultationForm language={language} />
        </div>
      </div>
    </section>
  );
};

export default NewHeroSection;